document.addEventListener('DOMContentLoaded', function(){
  /* ---- Sticky add-to-cart: aparece al pasar el héroe ---- */
  var bar = document.getElementById('stickyAtc');
  var heroBtn = document.getElementById('heroAtc') || document.querySelector('.product__info-wrapper .shopify-payment-button, .product__info-wrapper button[name="add"]');
  function onScroll(){
    if(!bar) return;
    var y = heroBtn ? heroBtn.getBoundingClientRect().bottom : 600;
    bar.classList.toggle('show', y < 0);
  }
  document.addEventListener('scroll', onScroll, {passive:true});
  onScroll();

  /* ---- Cuenta atrás de urgencia (termina a medianoche local) ---- */
  var cd = document.getElementById('puroCountdown');
  if(cd){
    var tick = function(){
      var now = new Date();
      var end = new Date(now);
      end.setHours(23,59,59,999);
      var s = Math.max(0, Math.floor((end - now)/1000));
      var h = String(Math.floor(s/3600)).padStart(2,'0');
      var m = String(Math.floor((s%3600)/60)).padStart(2,'0');
      var ss = String(s%60).padStart(2,'0');
      cd.textContent = h+':'+m+':'+ss;
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---- Popup de salida (una vez por sesión) ---- */
  var pop = document.getElementById('exitPopup');
  var closeBtn = document.getElementById('exitClose');
  if(pop){
    var shown = false;
    var show = function(){
      if(shown || sessionStorage.getItem('puro_exit')) return;
      shown = true;
      pop.hidden = false;
      sessionStorage.setItem('puro_exit','1');
    };
    var hide = function(){ pop.hidden = true; };
    document.addEventListener('mouseout', function(e){
      if(!e.relatedTarget && e.clientY <= 0) show();
    });
    if(closeBtn) closeBtn.addEventListener('click', hide);
    pop.addEventListener('click', function(e){ if(e.target === pop) hide(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') hide(); });
    setTimeout(function(){
      if(!sessionStorage.getItem('puro_exit') && window.scrollY > 1200) show();
    }, 12000);
  }

  /* ---- Radios de pack: resalta el seleccionado ---- */
  var pack = document.querySelector('.pack');
  if(pack){
    pack.addEventListener('change', function(){
      pack.querySelectorAll('label').forEach(function(l){
        l.classList.toggle('on', l.querySelector('input').checked);
      });
    });
  }

  /* ---- Scroll reveal suave (solo si el usuario no pide menos movimiento) ---- */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!reduce && 'IntersectionObserver' in window){
    var targets = document.querySelectorAll(
      '.section .sec-head, .card, .bcard, .rev, .step, .pack-card, .media, .hero > div:last-child, .faq-list, .table, .grid2 > *'
    );
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){
          en.target.classList.add('in');
          io.unobserve(en.target);
        }
      });
    }, {rootMargin:'0px 0px -8% 0px', threshold:.12});

    Array.prototype.forEach.call(targets, function(el, i){
      el.classList.add('reveal');
      el.style.transitionDelay = (Math.min(i,5) * 55) + 'ms';
      io.observe(el);
    });

    // Fallback: si algo queda fuera de vista tras 1.5s, muéstralo
    setTimeout(function(){
      document.querySelectorAll('.reveal:not(.in)').forEach(function(el){
        var r = el.getBoundingClientRect();
        if(r.top < window.innerHeight && r.bottom > 0) el.classList.add('in');
      });
    }, 1500);
  }

  /* ---- FAQ: solo uno abierto a la vez ---- */
  var faqs = document.querySelectorAll('details.faq');
  faqs.forEach(function(d){
    d.addEventListener('toggle', function(){
      if(d.open) faqs.forEach(function(o){ if(o!==d) o.open = false; });
    });
  });
});

/* ========================================================================
   Analytics — puntos de integración (GA4 / GTM / Shopify)
   Eventos: product_view, hero_cta_click, cta_click, add_to_cart,
            checkout_started, purchase, scroll_depth, faq_interaction
   Se envían a window.dataLayer y se emiten como evento DOM 'puro:*'.
   ===================================================================== */
(function(){
  function track(name, data){
    var payload = Object.assign({ event: name }, data || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    try{ document.dispatchEvent(new CustomEvent('puro:' + name, { detail: payload })); }catch(e){}
    if(window.console && console.debug) console.debug('[puro]', name, payload);
  }
  window.puroTrack = track;

  document.addEventListener('DOMContentLoaded', function(){
    var main = document.querySelector('main[data-template]');
    var tpl = (main && main.dataset.template) || '';

    if(tpl === 'product') track('product_view');

    document.addEventListener('click', function(e){
      var el = e.target && e.target.closest ? e.target : null;
      if(!el) return;
      var target = e.target.closest ? e.target : e.target.parentElement;

      var anchor = target && target.closest && target.closest('a[href="#comprar"]');
      if(anchor){
        var inHero = anchor.closest('.product__info-wrapper, .sticky');
        track(inHero ? 'hero_cta_click' : 'cta_click', {
          label: (anchor.textContent || '').trim().slice(0, 40),
          section: (anchor.closest('section') && anchor.closest('section').className) || ''
        });
      }

      var atc = target && target.closest && target.closest('button[name="add"], .shopify-payment-button');
      if(atc){
        track('add_to_cart', { location: atc.classList.contains('shopify-payment-button') ? 'dynamic_checkout' : 'product_form' });
        if(atc.classList.contains('shopify-payment-button')) track('checkout_started', { method: 'dynamic_checkout' });
      }
    });

    document.addEventListener('submit', function(e){
      var f = e.target;
      if(f && f.getAttribute && (f.getAttribute('action')||'').indexOf('/cart') > -1){
        track('checkout_started', { method: 'cart_form' });
      }
    });

    document.addEventListener('toggle', function(e){
      if(e.target && e.target.matches && e.target.matches('details.faq')) track('faq_interaction');
    });

    /* Profundidad de scroll: 25 / 50 / 75 / 100, una sola vez cada una */
    var marks = [25,50,75,100], seen = {};
    function onScroll(){
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if(h <= 0) return;
      var pct = (window.pageYOffset / h) * 100;
      marks.forEach(function(m){
        if(!seen[m] && pct >= m){ seen[m] = true; track('scroll_depth', { percent: m }); }
      });
    }
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Purchase — Shopify thank-you page */
    if(/\/thank_you|\/orders\/[^/]+\/(confirm|thanks)/.test(location.pathname)) track('purchase');
  });
})();
